var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToolbarback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.593 1.05804C10.2098 0.886464 9.78339 0.820381 9.36246 0.867319C8.94152 0.914257 8.54296 1.07233 8.2122 1.32352L2.718 5.62229L2.56718 5.77545V1.87491C2.56718 1.6041 2.45368 1.34438 2.25165 1.15289C2.04962 0.961402 1.77561 0.853823 1.48989 0.853823C1.20417 0.853823 0.930161 0.961402 0.72813 1.15289C0.526098 1.34438 0.412598 1.6041 0.412598 1.87491V12.0857C0.412598 12.3566 0.526098 12.6163 0.72813 12.8078C0.930161 12.9993 1.20417 13.1068 1.48989 13.1068C1.77561 13.1068 2.04962 12.9993 2.25165 12.8078C2.45368 12.6163 2.56718 12.3566 2.56718 12.0857V8.18521L2.718 8.33837L8.2122 12.6371C8.60823 12.9415 9.10278 13.1074 9.61268 13.1068C9.95098 13.1049 10.2851 13.0354 10.593 12.9026C10.9261 12.7635 11.2099 12.5364 11.4104 12.2485C11.611 11.9606 11.7199 11.6241 11.7242 11.2791V2.68156C11.7199 2.33659 11.611 2.00006 11.4104 1.71217C11.2099 1.42428 10.9261 1.19719 10.593 1.05804ZM9.56959 11.0647L4.37704 6.98033L9.56959 2.98789V11.0647Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolbarback);
export default __webpack_public_path__ + "static/media/toolbarback.e62677ad267a8d8ffb82a612b9e2e9fd.svg";
export { ForwardRef as ReactComponent };